/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
      'onDrawerOpen': ajaxCart.load
    });
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');
      $quantityLabel = $(".product-single__qty-select-wrapper .variant-qty-label")
      $frequencyLabel = $(".variant-frequency-label")

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      // Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    $quantityLabel.show();
    $frequencyLabel.show();

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html("Compare at" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    // Delegated + live lookups so it survives the subscribe page's buy-box swap
    $(document).on('click', '#ProductThumbs .thumbnail-image', function(evt) {
      evt.preventDefault();
      var newImage = $(this).find("a").attr('href');
      var newAlt = $(this).find("img").attr('alt');
      timber.switchImage(newImage, null, $('#ProductPhotoImg'), newAlt);
    });
  }
};

timber.switchImage = function (src, imgObject, el, alt = "") {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
  if (alt != "") {
    $el.attr('alt', alt);
  }
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    $("#gorgias-web-messenger-container").hide()

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);

    if (!$("body").hasClass("fixedPosition")) {
      this._scrollTop = $(window).scrollTop();
      $("body").addClass("fixedPosition").css("top", -this._scrollTop + "px")
    }
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    $("#gorgias-web-messenger-container").show()

    $("body").removeClass("fixedPosition").css("top", "");
    if (this._scrollTop != null) {
      $(window).scrollTop(this._scrollTop);
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);


// User Defined JS

function truncate(string){
 if (string.length > 25)
  return string.substring(0,25)+'...';
 else
  return string;
}

function copyToClipboard(string) {
  let textarea;
  let result;

  try {
    textarea = document.createElement('textarea');
    textarea.setAttribute('readonly', true);
    textarea.setAttribute('contenteditable', true);
    textarea.style.position = 'fixed'; // prevent scroll from jumping to the bottom when focus is set.
    textarea.value = string;
    textarea.ontouchend = function (e) {
      e.preventDefault();
    };

    textarea.onfocus = function (e) {
        e.preventDefault();
        var scrollNumber = $(document).scrollTop()
        window.scrollTo(0, scrollNumber);
        document.body.scrollTop = scrollNumber;
    }

    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();

    const range = document.createRange();
    range.selectNodeContents(textarea);

    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);

    textarea.setSelectionRange(0, textarea.value.length);
    result = document.execCommand('copy');
  } catch (err) {
    console.error(err);
    result = null;
  } finally {
    document.body.removeChild(textarea);
  }

  // manual copy fallback using prompt
  if (!result) {
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    const copyHotkey = isMac ? '⌘C' : 'CTRL+C';
    result = prompt("Press " + copyHotkey, string); // eslint-disable-line no-alert
    if (!result) {
      return false;
    }
  }
  return true;
}

function waitForQtySelectorToDisplay(selector, time) {
  if($(selector).length > 0) {
    $(selector).focus(function(e) {
      $(selector).blur()
    })
    return;
  }
  else {
    setTimeout(function() {
        waitForQtySelectorToDisplay(selector, time);
    }, time);
  }
}

$(document).ready(function () {
  const $backgrounds = $('.hero-section.home-hero-section .content-background');
  const $mobileBanners = $('.hero-section.home-hero-section .content .banner');
  const $siteHeader = $('.template-index .site-header');
  const $heroSection = $('.hero-section.home-hero-section');
  const $contentText = $('.home-hero-section .content-text');
  if ($backgrounds.length === 0 && $mobileBanners.length === 0) {
    return;
  }

  let currentIndex = 0;
  const colors = ['#A9F134', '#FFDF2C', '#FF9F69'];

  function loadSlideBackground($el) {
    var bg = $el.attr('data-bg');
    if (!bg || $el.data('bgLoaded')) {
      return;
    }
    $el.css('background-image', 'url(' + bg + ')');
    $el.data('bgLoaded', true);
  }

  function animateOpacity() {
    const isDesktop = $(window).width() > 768;
    const slideCount = Math.max($backgrounds.length, $mobileBanners.length);
    const nextIndex = (currentIndex + 1) % slideCount;

    loadSlideBackground($backgrounds.eq(nextIndex));
    loadSlideBackground($mobileBanners.eq(nextIndex));

    $backgrounds.eq(currentIndex).animate({ opacity: 0 }, 1000);
    $mobileBanners.eq(currentIndex).animate({ opacity: 0 }, 1000);

    $backgrounds.eq(nextIndex).animate({ opacity: 1 }, 1000);
    $mobileBanners.eq(nextIndex).animate({ opacity: 1 }, 1000);

    const nextColor = colors[nextIndex];
    $siteHeader.add($heroSection).animate({ backgroundColor: nextColor }, 1000);
    $contentText.animate({ backgroundColor: isDesktop ? 'transparent' : nextColor }, 1000);

    currentIndex = nextIndex;
  }

  setInterval(animateOpacity, 4000);
});

$(document).ready(function() {
  $("#CartDrawer").mouseenter(function() {
    $(".ajaxcart__product").css("position", "static")
  })

  // Product thumbnail border
  var thumbnailSelector = ".product-single__thumbnails li"
  var activeSelector = "active-thumbnail"
  $(thumbnailSelector).first().addClass(activeSelector)

  // Delegated so the tracker survives the subscribe page's buy-box swap
  $(document).on('click', thumbnailSelector, function(event) {
    $(thumbnailSelector).removeClass(activeSelector)
    $(event.target).closest(thumbnailSelector).addClass(activeSelector)
  })

  $(".subscribe-and-save .checkbox-container span,.subscribe-and-save .checkbox-container .subscribe-indent").click(function() {
    $(".subscribe-and-save .checkbox-container input").click()
  })
  
  // Flex landing extra
  
   $(".want-2-flavors-link").on( "click", function(e) {
    e.preventDefault();
    var headerHeight = $(".site-header").height()
    var subscribeIcon = $(this).closest(".subscribe-info")
    if ($(this).attr("id") == "two-pack") {
      $(".subscription-tooltip").addClass("two-pack")
      $(".subscription-tooltip").removeClass("three-pack")
    } else {
      $(".subscription-tooltip").addClass("three-pack")
      $(".subscription-tooltip").removeClass("two-pack")
    }
    $(".subscription-tooltip").toggle()
    if (window.innerWidth <= 768) {
      if (subscribeIcon.attr("data-status") == "closed") {
        $('body,html').animate({
          scrollTop: $("#subscription-tooltip-top").offset().top - (headerHeight + 80)
        }, 500)
        subscribeIcon.attr("data-status", "open")
      } else {
        subscribeIcon.attr("data-status", "closed")
      }
    }
  })
   
   if($('#skip-gif').length){
     //$('#skip-gif').css('opacity', 0);
     var gifVisible = false;
     $(window).scroll(function() {

      var current = $(this).scrollTop(),
      gifPos = $('#skip-gif').offset().top,
      path = 'https://cdn.shopify.com/s/files/1/0019/2020/4854/files/iMessagae-Alpha-V3.gif?v=1611083551';
      

      if (current > (gifPos - 425)) {
        if (!gifVisible) {
          gifVisible=true;
          $('#skip-gif').attr('src', path);
        } 
      //$('#skip-gif').attr('src', path);
      }
      //else if (visible) $('#skip-gif').fadeTo(0,0);
    });
   }
  
  // Subscribe Tooltip
  $(".shot-price-subscription .subscribe-info-toggle").click(function(event) {
    event.preventDefault();
    event.stopPropagation();
    var headerHeight = $(".site-header").height()
    var subscribeIcon = $(this).closest(".subscribe-info-toggle")
    $(".subscription-tooltip").toggle()
    if (window.innerWidth <= 768) {
      if (subscribeIcon.attr("data-status") == "closed") {
        $('body,html').animate({
          scrollTop: $("#subscription-tooltip-top").offset().top - (headerHeight + 80)
        }, 500)
        subscribeIcon.attr("data-status", "open")
      } else {
        subscribeIcon.attr("data-status", "closed")
      }
    }
  })

  $(".cart-frequency-tooltip .close-tooltip, .cart-frequency-tooltip .acknowledge-button").click(function() {
    $(".cart-frequency-tooltip").hide();
    $(".account__loading-overlay").hide()
  })

  $(".review-products-tooltip .close-tooltip").click(function() {
    $(".review-products-tooltip").hide();
    $(".account__loading-overlay").hide()
  })

  $(".subscription-tooltip .close-tooltip").click(function() {
    $(".subscription-tooltip").hide()

    if ($(this).closest(".flavor-bundle-tooltip").length < 1) {
      var headerHeight = $(".site-header").height()
      if (window.innerWidth <= 768) {
        $('body,html').animate({
          scrollTop: $("#subscribe-box").offset().top - (headerHeight + 30)
        }, 500)
        $(".subscribe-info").attr("data-status", "closed")
      }
    }
  })

  $(".cart-bulk-discoun-tooltip .close-tooltip").click(function() {
    $(".cart-bulk-discoun-tooltip").hide()
    $(".account__loading-overlay").hide()
  })

  // Hide thumbnails for unselected flavors
  function toggleThumbs(start, end, direction) {
    for (var i = start; i < end; i++) {
      var thumb = $(".thumbnail-image" + i)
      if (direction == "hide") {
        thumb.hide()
      } else {
        thumb.css("display", "inline-block")
        if (i == start) {
          thumb.click()
        }
      }      
    }
  }

  // Product image gallery nav arrows
  // Delegated so the handler survives the subscribe page's buy-box swap
  $(document).on('click', ".product-single__nav-arrow", function(e) {
    var navDirection = $(e.target).data("direction")
    var activeThumbIndex = parseInt($(".active-thumbnail").data("id"))
    var numberOfThumbs = $(".product-single__thumbnails .thumbnail-image").length
    if (isNaN(activeThumbIndex)) {
      // A swapped-in gallery has no active thumbnail yet — seed it from
      // the first visible thumb so the arrows have a starting point.
      var firstVisible = $(".product-single__thumbnails .thumbnail-image").filter(function() {
        return $(this).css("display") != "none"
      }).first()
      firstVisible.addClass("active-thumbnail")
      activeThumbIndex = parseInt(firstVisible.data("id")) || 1
    }
    if (navDirection == "right") {
      for (var i = activeThumbIndex+1; i < numberOfThumbs+2; i++) {
        nextThumb = $(".product-single__thumbnails .thumbnail-image[data-id='" + i + "']")
        if (i == numberOfThumbs + 1) {
          i = 0;
        } else if (nextThumb.css("display") != "none") {
          nextThumb.click()
          break;
        }
      }
    } else {
      for (var i = activeThumbIndex-1; i > -1; i--) {
        prevThumb = $(".product-single__thumbnails .thumbnail-image[data-id='" + i + "']")
        if (i == 0) {
          i = numberOfThumbs + 1;
        } else if (prevThumb.css("display") != "none") {
          prevThumb.click()
          break;
        }
      }
    }
  })

  // Change product image when different flavor selected
  function changeImageFlavor(selectedFlavor) {
    
    var strippedFlavor = selectedFlavor.replace(/\s/g, "")
    if (strippedFlavor == "Strawberry") {
      toggleThumbs(1,6,"show")
      toggleThumbs(6,11,"hide")
    } else if (strippedFlavor == "SourLemonLime") {
      toggleThumbs(1,6,"hide")
      toggleThumbs(6,11,"show")
    } else if (strippedFlavor == "Blackberry") {
      toggleThumbs(1,6,"show")
      toggleThumbs(6,41,"hide")
    } else if (strippedFlavor == "Ginger") {
      toggleThumbs(1,6,"hide")
      toggleThumbs(6,11,"show")
      toggleThumbs(11,41,"hide")
    } else if (strippedFlavor == "PeachMango") {
      toggleThumbs(1,11,"hide")
      toggleThumbs(11,16,"show")
      toggleThumbs(16,41,"hide")
    } else if (strippedFlavor == "Apple") {
      toggleThumbs(1,16,"hide")
      toggleThumbs(16,21,"show")
      toggleThumbs(21,41,"hide")
    } else if (strippedFlavor == "LemonLime") {
      toggleThumbs(1,21,"hide")
      toggleThumbs(21,26,"show")
      toggleThumbs(26,41,"hide")
    } else if (strippedFlavor == "StrawberryKiwi") {
      toggleThumbs(1,26,"hide")
      toggleThumbs(26,31,"show")
      toggleThumbs(31,41,"hide")
    } else if (strippedFlavor == "Originals(Variety)") {
      toggleThumbs(1,31,"hide")
      toggleThumbs(31,36,"show")
      toggleThumbs(36,41,"hide")
    } else if (strippedFlavor == "Favorites(Variety)") {
      toggleThumbs(1,36,"hide")
      toggleThumbs(36,41,"show")
    } else {
      toggleThumbs(1,16,"hide")
      toggleThumbs(16,21,"show")
      toggleThumbs(21,41,"hide")
    }

    /* 
    if (strippedFlavor == "Blackberry") {
      toggleThumbs(1,6,"show")
      toggleThumbs(6,41,"hide")
    } else if (strippedFlavor == "Ginger") {
      toggleThumbs(1,6,"hide")
      toggleThumbs(6,11,"show")
      toggleThumbs(11,41,"hide")
    } else if (strippedFlavor == "PeachMango") {
      toggleThumbs(1,11,"hide")
      toggleThumbs(11,16,"show")
      toggleThumbs(16,41,"hide")
    } else if (strippedFlavor == "Apple") {
      toggleThumbs(1,21,"hide")
      toggleThumbs(21,26,"show")
      toggleThumbs(26,41,"hide")
    } else if (strippedFlavor == "LemonLime") {
      toggleThumbs(1,26,"hide")
      toggleThumbs(26,31,"show")
      toggleThumbs(31,41,"hide")
    } else if (strippedFlavor == "StrawberryKiwi") {
      toggleThumbs(1,31,"hide")
      toggleThumbs(31,36,"show")
      toggleThumbs(36,41,"hide")
    } else if (strippedFlavor == "Favorites(Variety)") {
      toggleThumbs(1,36,"hide")
      toggleThumbs(36,41,"show")
    } else {
      toggleThumbs(1,16,"hide")
      toggleThumbs(16,21,"show")
      toggleThumbs(22,41,"hide")
    }
    */

    $("#ProductPhotoImg").show()
    
  }

  var flavorSelector = ".flavor-wrapper .single-option-selector"

  if ($(flavorSelector).length > 0) {
    changeImageFlavor($(flavorSelector).val())
  }

  $(document.body).on('change', flavorSelector, function() {
    var selectedFlavor = $(this).val()
    if ($(this).closest(".landing-nutrition-container").length < 1) {
      changeImageFlavor(selectedFlavor)
    }
  })

  // Smooth Scrolling
  var scrollLink = $('.scroll')
  scrollLink.click(function(e) {
    e.preventDefault();
    var scrollOffset = 110;
    if (window.location.pathname == "/") {
      scrollOffset = 140;
    }
    $('body,html').animate({
      scrollTop: $(this.hash).offset().top - scrollOffset
    }, 500)
  })

  $(window).scroll(function () {
    if ($(".hamburger-icon").attr("data-status") == "closed") {
      if ($(window).scrollTop() > 52) {
        $('.site-header').addClass('fixed-nav');
        $('.site-header').css("background-color", "white");
        $('.site-header').css("animation", "none");
        if ($(".desktop-nav-slider").is(":hidden") && $(".mobilve-nav-slider").is(":hidden")) {
          $('.site-header').css("opacity", 0.95);
        }
      }

      if ($(window).scrollTop() < 53) {
        if ($(".desktop-nav-slider").is(":hidden")) {
          $('.site-header').removeClass('fixed-nav');

          if ($(".template-index").length < 1) {
            $('.site-header').attr("style", "")
          }
        }
      }
    }
  });

  $(".site-header .wrapper .hamburger-icon").click(function() {
    var hamburgerIcon = $(".site-header .wrapper .hamburger-icon")
    if (hamburgerIcon.attr("data-status") == "closed") {
      hamburgerIcon.attr("data-status", "open")
      hamburgerIcon.attr("aria-label", "Close Navigation Menu")
      $('.site-header').addClass('fixed-nav');
      $(".site-header .mobile-nav").show();
    } else {
      hamburgerIcon.attr("data-status", "closed")
      hamburgerIcon.attr("aria-label", "Open Navigation Menu")
      $(".site-header .mobile-nav").hide();
      if ($(window).scrollTop() < 53) {
        $('.site-header').removeClass('fixed-nav');
      }
    }
  })

  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      /* Toggle between adding and removing the "active" class,
      to highlight the button that controls the panel */
      this.classList.toggle("active");

      /* Toggle between hiding and showing the active panel */
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }

  // Science Studies JS
  $(".studies-section .cta-button").click(function(event) {
    var target = $(event.target)
    var wrapper = target.closest(".studies-section-wrapper")
    var dataType = target.attr("data-type")
    if (wrapper.attr("data-status") == "closed") {
      if (dataType == "green-tea") {
        wrapper.find(".study.hidden[data-filter='caffeine']").show()
        wrapper.find(".study.hidden[data-filter='caffeine']").closest("a").attr("aria-hidden",false);
        wrapper.find(".study.hidden[data-filter='caffeine']").closest("a").show()
      } else {
        wrapper.find(".study.hidden").show()
        wrapper.find(".study.hidden").closest("a").attr("aria-hidden",false);
        wrapper.find(".study.hidden").closest("a").show()
      }
      wrapper.attr("data-status", "open")
      target.text("Show Less")
    } else {
      wrapper.find(".study.hidden").hide()
      wrapper.find(".study.hidden").closest("a").attr("aria-hidden",true);
      wrapper.find(".study.hidden").closest("a").hide()
      wrapper.attr("data-status", "closed")
      target.text("Show all " + target.attr("data-number") + " Studies")
      $('body,html').animate({
        scrollTop: $("#" + dataType).offset().top - 120
      }, 500)
    }
  })

  function styleStudyRows(wrapper, filter) {
    if (window.innerWidth > 768) {
      var row = []
      wrapper.find(".study").removeClass("no-margin-right")
      var studiesSelector = filter == "all" ? ".study" : ".study[data-filter='" + filter + "']"
      var studies = wrapper.find(studiesSelector)
      studies.each(function(i) {
        row.push($(this))
        if ([2, 5, 8, 11, 14, 17, 20].includes(i) || (i+1) == studies.length) {
          $(this).addClass("no-margin-right")
          var height = 0;
          row.forEach(function(element) {
            element.css("height", "auto")
            if (element.height() > height) { height = element.height() }
          })
          row.forEach(function(element) {
            element.height(height)
          })

          row = []
        }
      })
    }
  }

  $( window ).resize(function() {
    styleStudyRows($(".studies-section.ginseng .studies-section-wrapper"), "all")
    styleStudyRows($(".studies-section.green-tea .studies-section-wrapper"), "all")
  });

  styleStudyRows($(".studies-section.ginseng .studies-section-wrapper"), "all")
  styleStudyRows($(".studies-section.green-tea .studies-section-wrapper"), "all")

  $(".studies-section .studies-nav .studies-nav-tab").click(function(event) {
    var target = $(event.target)
    var filter = target.attr("data-filter")
    var wrapper = target.closest(".studies-section-wrapper")
    $(".studies-section .studies-nav .studies-nav-tab").removeClass("active-tab")
    target.addClass("active-tab")

    if (filter == "caffeine") {
      wrapper.find(".study").show()
      wrapper.find(".study").closest("a").attr("aria-hidden", "false")
      wrapper.find(".study").closest("a").show()
      wrapper.find(".cta-button").show()
      if (wrapper.attr("data-status") == "open") {
        wrapper.find(".cta-button").click()
      } else {
        wrapper.find(".study.hidden").hide()
        wrapper.find(".study.hidden").closest("a").attr("aria-hidden", "true")
        wrapper.find(".study.hidden").closest("a").hide()
      }
    } else {
      wrapper.find(".study").hide()
      wrapper.find(".study").closest("a").attr("aria-hidden", "true")
      wrapper.find(".study").closest("a").hide()
      wrapper.find(".study[data-filter='" + filter + "']").show()
      wrapper.find(".study[data-filter='" + filter + "']").closest("a").attr("aria-hidden", "false")
      wrapper.find(".study[data-filter='" + filter + "']").closest("a").show()
      wrapper.find(".cta-button").hide()
      wrapper.find(".row-clear").hide()
    }

    styleStudyRows(wrapper, filter)
  })

  window.shotsIds = [19456851705910, 8043982422318, 1563105689654]
  var shotsIds = window.shotsIds

  Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
    return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper('ifEither', function(arg1, arg2, arg3, options) {
    return (arg1 == arg2 || arg1 == arg3) ? options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper('ifContains', function(arg1, arg2, options) {
    return (arg1.includes(arg2)) ? options.fn(this) : options.inverse(this);
  });

  Handlebars.registerHelper('totalShots', function(arg1, arg2) {
    var shotNumber = shotsIds.includes(arg2) ? 6 : 10;
    return (arg1 * shotNumber);
  });

  Handlebars.registerHelper('itemLabel', function(arg1) {
    return (shotsIds.includes(arg1)) ? "Shots" : "Servings";
  });

  $(".rewards__referral-link").click(function() {
    var linkText = $(".swell-referral-link").text()
    copyToClipboard(linkText)

    $(".rewards__referral-link-copied").addClass("fade-in")

  })

  // Swell custom setup
  $(document).on("swell:setup", function(){
    // Set success state on completed campaigns
    var customerDetails = swellAPI.getCustomerDetails();
    var createAccountBonus = false;

    $(".leave-review-link").click(function(e) {
      e.preventDefault();
      $(".review-products-tooltip").show();
      $("body").append("<div class='account__loading-overlay'></div>");
    })

    customerDetails.actionHistoryItems.forEach(function(item) {
      if (item.action.toLowerCase() == "like our facebook page") {
        $(".rewards__facebook-box").addClass("completed")
      } else if (item.action == "Follow us on Instagram") {
        $(".rewards__instagram-box").addClass("completed")
      } else if (item.action == "Follow us on TikTok") {
        $(".rewards__tiktok-box").addClass("completed")
      } else if (item.action == "Write A Review") {
        $(".rewards__write-review-box").addClass("completed")
        //$(".rewards__write-review-box").unwrap()
        $(".rewards__write-review-box").attr("data-campaign-id", "502799")
      } else if (item.action == "Create an account" || item.action == "Create Account") {
        createAccountBonus = true;
        
      // } else if (item.action == "Happy Birthday") {
      //  $(".rewards__birthday-box").addClass("completed")
      } else if (item.action == "Spend $99") {
        if (item.status != "Approved") {
          $(".rewards__spend-amount").text((item.status.split("%")[0] / 100 * 99).toFixed(0))
          $(".rewards__spend-progress-bar").css("width", item.status)
        }
      }
    });

    

    if (!createAccountBonus) {
      var newBalance = customerDetails.pointsBalance + 2
      $(".swell-point-balance-main").hide()
      $(".swell-point-balance-backup").text(newBalance)
      $(".swell-point-balance-backup").show()
    }

    // Display Referrals
    if (customerDetails.referrals.length > 0) {
      var i = 0;
      customerDetails.referrals.forEach(function(referral) {
        i++;
        var referralClass = "not-accepted"
        var referralStatus = "Not accepted"
        if (referral.completedAt) {
          referralClass = "accepted"
          referralStatus = "Accepted"
        }

        var extraStyle = "";
        if (i > 3) { extraStyle = "display: none;" }

        var referralString = "<div style='" + extraStyle + "' class='rewards__referral-list-item " + referralClass + "'>"
        referralString += "<div class='rewards__referral-email'>" + truncate(referral.email) + "</div>"
        referralString += "<div class='rewards__referral-status'>" + referralStatus + "</div>"
        referralString += "<div class='clear'></div>"
        referralString += "</div>"

        $(".rewards__referrals-list").append(referralString)
      })
      if (customerDetails.referrals.length > 3) {
        $(".rewards__referrals-list").append("<div class='cta-button'>See More</div>")

        $(".rewards__referrals-list .cta-button").click(function() {
          $(".rewards__referrals-list .rewards__referral-list-item").show()
          $(".rewards__referrals-list .cta-button").hide()
        })
      }
    } else {
      $(".rewards__referrals-list").append("<p class='rewards__no-referrals-message'>You don't have any referrals yet.</p>")
    }

    // Handle sending referral emails
    var referredCustomersInput = $("#rewards__refer-email-capture");
    var sendEmailsBtn = $("#rewards__refer-email-submit");

    $(sendEmailsBtn).click(function() {
      // assuming you allowed comma separated email input
      var emails = referredCustomersInput.val().split(",");

      var referrals = []
      $(".rewards__referrals-list .rewards__referral-list-item .rewards__referral-email").each(function() {
        referrals.push($(this).text().trim())
      })

      var duplicates = []
      emails.forEach(function(email) {
        if (referrals.includes(email.trim().toLowerCase())) {
          duplicates.push(email)
        }
      })

      for( var i = emails.length; i > -1; i--){ 
        if (duplicates.includes(emails[i])) {
          emails.splice(i, 1);
        }
      }

      window.duplicateReferrals = duplicates

      var onSuccess = function() {
        $(".rewards__refer-success-message").show();
        referredCustomersInput.val("")
        showDuplicatesMessage()
      }

      var onError = function(err) {
        $(".rewards__refer-fail-message").show();
      }

      var showDuplicatesMessage = function() {
        if (window.duplicateReferrals.length > 0) {
          $(".rewards__duplicate-emails").text(window.duplicateReferrals.join(", "))
          $(".rewards__refer-duplicate-message").show();
        }

        window.duplicateReferrals = []
      }

      if (emails.length > 0) {
        swellAPI.sendReferralEmails(emails,onSuccess, onError);
      } else {
        showDuplicatesMessage()
      }

    });

    var verifyEmailError = $(".errors li:contains(please click the link included to verify your email address)")
    if (verifyEmailError.length > 0) {
      $(".form-left").hide()
      $(".additional-links").hide()
      verifyEmailError.closest(".errors").addClass("verify-email-warning")
    }


    $(".account-main.form-page").show();
    $(".account_form-spacer").hide();
    
    $(".rewards__loading-overlay, .rewards__loading-spinner").hide();

    if ($.fn.stickySidebar) {
      $('#account-sidebar, #customer_tab_nav').stickySidebar({
        topSpacing: 125,
        minWidth: 1100
      });
    }

  })

  var initStickySidebar = function() {
    if (!$.fn.stickySidebar) {
      return;
    }
    $('#faq-sidebar').stickySidebar({
      topSpacing: 150,
      minWidth: 991
    });
  }

  initStickySidebar()

  

  if (is.edge() == false && is.ie() == false) {
    var calculatorSelector = ".calculator-selector"

    if ($(calculatorSelector).length > 0) {
      $('body').click(function(e) {
        if (e.target.className != "calculator-selector-wrapper") {
          $("#caf-calculator .calculator-selector").hide()
        }
      })
    }

    $("#caf-calculator .single-option-selector").on('mousedown', function(e) {
      e.preventDefault();
      this.blur();
      window.focus();

      $(".calculator-selector").hide()

      $(this).closest(".calculator-selector-wrapper").find(calculatorSelector).show()
    })

    $(".calculator-selector-option").click(function() {
      $(this).closest(".calculator-selector-wrapper").find(calculatorSelector + " .calculator-selector-option").removeClass("selected")
      $(this).addClass("selected")
      $(this).closest(".calculator-selector-wrapper").find(".single-option-selector").val($(this).text()).change()
      $(this).closest(".calculator-selector").hide()
    })
  }

  $(".claculator-row .cta-button").click(function() {
    var calculatorAge = $(".calculator-selector-wrapper select[name='age']").val()
    var calculatorHealth = $(".calculator-selector-wrapper select[name='health']").val()

    var caffeineLimit = 400;
    
    if (calculatorHealth == "Health Issues") {
      caffeineLimit = "";
    } else if (calculatorAge == "Child 0-12") {
      caffeineLimit = 0
    } else if (calculatorAge == "Teenager 13-18") {
      caffeineLimit = 100
    } else if (calculatorHealth == "Pregnant" ) {
      caffeineLimit = 200
    }

    $(".caffeine-max-dose").text(caffeineLimit)
    $(".caffeine-dose-label").show()

    if (calculatorHealth == "Health Issues") {
      $(".caffeine-dose-label").hide()
      $(".consult-doctor-text").show()
    } else {
      $(".caffeine-dose-label").show()
      $(".consult-doctor-text").hide()
    }
  })

  if (is.edge() == false && is.ie() == false) {
    var flavorSelectMenuSelector = ".flavor-select-menu"
    var frequencySelectMenuSelector = ".frequency-select-menu"

    // rotate gummies landing page default flavor
    if (window.location.href.includes("/gummies-flex")) {
      var todayDate = new Date()
      var todayNumber = todayDate.getDate()

      if (todayNumber % 2 == 0) {
        $(".flavor-select-menu-option[data-id='47760735174958']").removeClass("selected")
        $(".flavor-select-menu-option[data-id='47760735207726']").addClass("selected")
      }
    }

    $(".flavor-wrapper .single-option-selector").on('mousedown', function(e) {
      e.preventDefault();
      this.blur();
      window.focus();

      if ($(this).attr("data-id")) {
        if ($(this).attr("data-id") == "4") {
          function delayOpen() {
            $(".flavor-select-menu[data-id='4']").show()
          }

          setTimeout(delayOpen, 100);
        } else {
          $(flavorSelectMenuSelector + "[data-id='" + $(this).attr("data-id") + "']").show()
        }
      } else {
        $(flavorSelectMenuSelector).show()
      }
    })

    $(".frequency-wrapper .single-option-selector").on('mousedown', function(e) {
      e.preventDefault();
      this.blur();
      window.focus();

      if ($(this).attr("data-id")) {
        if ($(this).attr("data-id") == "4") {
          function delayOpen() {
            $(".frequency-select-menu[data-id='4']").show()
          }

          setTimeout(delayOpen, 100);
        } else {
          $(frequencySelectMenuSelector + "[data-id='" + $(this).attr("data-id") + "']").show()
        }
      } else {
        $(frequencySelectMenuSelector).show()
      }
    })

    var flexImages = {
      "Peach Mango": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_3_-_Green.jpg?v=1632353828"
      },
      "Blackberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_3_-_Green.jpg?v=1632353828"
      },
      "Ginger": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_3_-_Green.jpg?v=1632353828"
      },
      "Originals (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828",
        "five": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_5-min.jpg?v=1663795095"
      },
      "Apple": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"
      },
      "Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"
      },
      "Strawberry Kiwi": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"
      },
      "Favorites (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"        
      },
      "Strawberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"        
      },
      "Sour Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"        
      }
    }

    var mobileFlexImages = {
      "Peach Mango": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_3.jpg?v=1632353828"
      },
      "Blackberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_3.jpg?v=1632353829"
      },
      "Ginger": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_3.jpg?v=1632353828"
      },
      "Originals (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3.jpg?v=1632353828",
        "four": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_4.jpg?v=1656270721",
        "five": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_5-min.jpg?v=1663795095"
      },
      "Apple": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"
      },
      "Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"
      },
      "Strawberry Kiwi": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"
      },
      "Favorites (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"
      },
      "Strawberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"
      },
      "Sour Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_1.jpg?v=1631822449",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2.jpg?v=1631822449",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3_-_Green.jpg?v=1632353828"
      }
    }

    //Super Flex
    
    var flexSuperImages = {
      "Peach Mango": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_2_8d5cd585-b427-424e-ba9b-79a55b64b209.jpg?v=1656270720",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_4.jpg?v=1656270720",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_-_Green.jpg?v=1656270720"
      },
      "Blackberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_2_956ec2a4-3a46-442d-b867-dc8bdb972cde.jpg?v=1656270720",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_4.jpg?v=1656270720",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_-_Green.jpg?v=1656270720"
      },
      "Ginger": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_2_79c910a4-65aa-43fd-b8a1-6897fd4c46a8.jpg?v=1656270720",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_4.jpg?v=1656270720",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_-_Green.jpg?v=1656270720"
      },
      "Originals (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2_1ea87352-f6ca-4337-9f11-e75b8c478e60.jpg?v=1656270720",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_4.jpg?v=1656270721",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_-_Green.jpg?v=1656270720"
      },
      "Apple": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Apple_2.jpg?v=1670877118",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Apple_4.jpg?v=1670877127",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Apple_-_Green.jpg?v=1670877333"
      },
      "Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Lemon_Lime_2.jpg?v=1670877216",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Lemon_Lime_4.jpg?v=1670877221",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Lemon_Lime_-_Green.jpg?v=1670877328"
      },
      "Strawberry Kiwi": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_2.jpg?v=1670877283",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_4.jpg?v=1670877300",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_-_Green.jpg?v=1670877308"
      },
      "Favorites (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_2_909ef5b8-7cb8-4fbc-aeed-88eefeb54349.jpg?v=1670879725",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_4_884941b6-8b1e-4808-8f4b-1a656bc99d59.jpg?v=1670879725",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_-_Green_c6341ee7-f785-4472-a6b3-a70de499c527.jpg?v=1670879725"
      },
      "Combo (All 6 Flavors)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_2_93cfd5bc-b381-4085-851b-882938dceba1.jpg?v=1670947507",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_4_820f990c-1287-48e0-9076-1a5423ec0d52.jpg?v=1670947507",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_-_Green.jpg?v=1670877169"
      },
      "Strawberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_2_909ef5b8-7cb8-4fbc-aeed-88eefeb54349.jpg?v=1670879725",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_4_884941b6-8b1e-4808-8f4b-1a656bc99d59.jpg?v=1670879725",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_-_Green_c6341ee7-f785-4472-a6b3-a70de499c527.jpg?v=1670879725"
      },
      "Sour Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_2_93cfd5bc-b381-4085-851b-882938dceba1.jpg?v=1670947507",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_4_820f990c-1287-48e0-9076-1a5423ec0d52.jpg?v=1670947507",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_-_Green.jpg?v=1670877169"
      }
    }

    var mobileSuperFlexImages = {
      "Peach Mango": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_2_8d5cd585-b427-424e-ba9b-79a55b64b209.jpg?v=1656270720",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_4.jpg?v=1656270720",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_8.jpg?v=1656270720"
      },
      "Blackberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_2_956ec2a4-3a46-442d-b867-dc8bdb972cde.jpg?v=1656270720",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_4.jpg?v=1656270720",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_8.jpg?v=1656270720"
      },
      "Ginger": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_2_79c910a4-65aa-43fd-b8a1-6897fd4c46a8.jpg?v=1656270720",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_4.jpg?v=1656270720",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_8.jpg?v=1656270720"
      },
      "Originals (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_2_1ea87352-f6ca-4337-9f11-e75b8c478e60.jpg?v=1656270720",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_4.jpg?v=1656270721",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_8.jpg?v=1656270703"
      },
      "Apple": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Apple_2.jpg?v=1670877118",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Apple_4.jpg?v=1670877127",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Apple_8.jpg?v=1670877135"
      },
      "Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Lemon_Lime_2.jpg?v=1670877216",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Lemon_Lime_4.jpg?v=1670877221",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Lemon_Lime_8.jpg?v=1670877226"
      },
      "Strawberry Kiwi": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_2.jpg?v=1670877283",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_4.jpg?v=1670877300",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_8.jpg?v=1670878047"
      },
      "Favorites (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_2_909ef5b8-7cb8-4fbc-aeed-88eefeb54349.jpg?v=1670879725",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_4_884941b6-8b1e-4808-8f4b-1a656bc99d59.jpg?v=1670879725",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_8_64a02bd4-fdf4-4c54-824e-df0c7b5eadef.jpg?v=1670879725"
      },
      "Combo (All 6 Flavors)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_2_93cfd5bc-b381-4085-851b-882938dceba1.jpg?v=1670947507",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_4_820f990c-1287-48e0-9076-1a5423ec0d52.jpg?v=1670947507",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_8_71d01e11-da78-439e-acf6-d2eeb166275e.jpg?v=1670947507"
      },
      "Strawberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_2_909ef5b8-7cb8-4fbc-aeed-88eefeb54349.jpg?v=1670879725",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_4_884941b6-8b1e-4808-8f4b-1a656bc99d59.jpg?v=1670879725",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_8_64a02bd4-fdf4-4c54-824e-df0c7b5eadef.jpg?v=1670879725"
      },
      "Sour Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_2_93cfd5bc-b381-4085-851b-882938dceba1.jpg?v=1670947507",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_4_820f990c-1287-48e0-9076-1a5423ec0d52.jpg?v=1670947507",
        "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Combo_8_71d01e11-da78-439e-acf6-d2eeb166275e.jpg?v=1670947507"
      }
    }

    //BOGO Flex
    
    var flexBogoImages = {
      "Peach Mango": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_3.jpg?v=1632353828",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_5-min.jpg?v=1663795096"
      },
      "Blackberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_3.jpg?v=1632353829",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_5-min.jpg?v=1663795096"
      },
      "Ginger": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_3.jpg?v=1632353828",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_5-min.jpg?v=1663795096"
      },
      "Originals (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3.jpg?v=1632353828",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_5-min.jpg?v=1663795095"
      },
      "Apple": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Apple_3.jpg?v=1674681900",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Apple_5.jpg?v=1674681905"
      },
      "Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Lemon_Lime_3.jpg?v=1674681981",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Lemon_Lime_5.jpg?v=1674681987"
      },
      "Strawberry Kiwi": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_3.jpg?v=1674682012",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_5.jpg?v=1674682019"
      },
      "Favorites (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_3.jpg?v=1674682092",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_5.jpg?v=1674682098"
      },
      "Strawberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_3.jpg?v=1674682012",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_5.jpg?v=1674682019"
      },
      "Sour Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_3.jpg?v=1674682092",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_5.jpg?v=1674682098"
      }
    }

    var mobileFlexBogoImages = {
      "Peach Mango": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_3.jpg?v=1632353828",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Peach_Mango_5-min.jpg?v=1663795096"
      },
      "Blackberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_3.jpg?v=1632353829",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blackberry_5-min.jpg?v=1663795096"
      },
      "Ginger": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_3.jpg?v=1632353828",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Ginger_5-min.jpg?v=1663795096"
      },
      "Originals (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_3.jpg?v=1632353828",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Variety_5-min.jpg?v=1663795095"
      },
      "Apple": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Apple_3.jpg?v=1674681900",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Apple_5.jpg?v=1674681905"
      },
      "Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Lemon_Lime_3.jpg?v=1674681981",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Lemon_Lime_5.jpg?v=1674681987"
      },
      "Strawberry Kiwi": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_3.jpg?v=1674682012",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_5.jpg?v=1674682019"
      },
      "Favorites (Variety)": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_3.jpg?v=1674682092",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_5.jpg?v=1674682098"
      },
      "Strawberry": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_3.jpg?v=1674682012",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Strawberry_Kiwi_5.jpg?v=1674682019"
      },
      "Sour Lemon Lime": {
        "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_3.jpg?v=1674682092",
        "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Favorites_5.jpg?v=1674682098"
      }
    }

    var comboFlexImages = {
      "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Gummy_1.jpg?v=1711567533",
      "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Gummy_Shots.jpg?v=1711567533",
      "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Gummy_2_Shots_White.jpg?v=1711635314"
    }

    var gummiesFlexImages = {
      "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Gummy_1_9a65f250-ad1c-444d-97ee-d0e3a090ebd9.jpg?v=1711652296",
      "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Gummy_2.jpg?v=1711652297",
      "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Gummy_3_-_2.jpg?v=1711652298"
    }

    var comboGummiesFlexImages = {
      "one": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Gummy_1.jpg?v=1711567533",
      "two": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Gummy_Shots.jpg?v=1711567533",
      "three": "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Gummy_2_Shots_White.jpg?v=1711635314"
    }

    function changeFlavorImages(flavor, flexImages) {
      $(".landing-qty-option .single-image").attr("src", flexImages[flavor]["one"])
      $(".landing-qty-option .double-image").attr("src", flexImages[flavor]["two"])
      $(".landing-qty-option .triple-image").attr("src", flexImages[flavor]["three"])
    }

    function changeMobileFlavorImage(flavor, count, flexImages) {
      var imageCount;
      if (window.location.href.includes("super-flex")) {
        if (count == 2) {
          imageCount = "one"
        } else if (count == 4) {
          imageCount = "two"
        } else {
          imageCount = "three"
        }
      } else if (window.location.href.includes("buy-three-get-two") || window.location.href.includes("pages/dozen")) {
        if (count == 3) {
          imageCount = "one"
        } else {
          imageCount = "two"
        } 
      } else if (window.location.href.includes("flex-thirty-day-welcome-offer")) {
        if (count == 2) {
          imageCount = "two"
        } else {
          imageCount = "five"
        } 
      } else {
        if (count == 1) {
          imageCount = "one"
        } else if (count == 2) {
          imageCount = "two"
        } else if (count == 4) {
          imageCount = "four"
        } else if (count == 5) {
          imageCount = "five"
        } else {
          imageCount = "three"
        }
      }

      if (window.location.href.includes("shots-gummies")) {
        $(".mobile-flex-flavor-select-image").attr("src", comboGummiesFlexImages[imageCount])
      } else if (window.location.href.includes("pages/gummies-flex")) {
        $(".mobile-flex-flavor-select-image").attr("src", gummiesFlexImages[imageCount])
      } else {
        $(".mobile-flex-flavor-select-image").attr("src", flexImages[flavor][imageCount])
      }
    }

    function chooseMobileImageType() {
      var imageBatch;
      if (window.location.href.includes("super-flex")) {
        imageBatch = mobileSuperFlexImages
      } else if (window.location.href.includes("buy-three-get-two") || window.location.href.includes("pages/dozen")) {
        imageBatch = mobileFlexBogoImages
      } else {
        imageBatch = mobileFlexImages
      }
      return imageBatch
    }

    $(".flex-tier .select-this-offer").on( "click", function(e) {
      e.preventDefault();
      $(".flex-tier .select-this-offer").removeClass('selected');
      $(".flex-tier .select-this-offer a").text('Select');

      var selectedOfferCount = $(this).data("count")
      $(".select-flavor-button").attr("data-qty", selectedOfferCount)

      var selectedOfferSelecter = ".select-this-offer-" + selectedOfferCount
      $(selectedOfferSelecter).addClass('selected');
      $(selectedOfferSelecter).find('a').text('Selected');

      var selectedOfferEl = $(this)

      if (window.location.href.includes("buy-three-get-two-free")) {
        var checkoutLinkEl = $(".flex-purchase-selectors .checkout-link")
        var checkoutLinkBase = checkoutLinkEl.attr("href").split(":")[0] + ":" + checkoutLinkEl.attr("href").split(":")[1]
        if (selectedOfferEl.closest(".landing-selector-wrapper").find(".single-option-selector").val() == "Combo (All 6 Flavors)") {
          var comboCheckoutLink = checkoutLinkBase
          comboCheckoutLink += ":"
          comboCheckoutLink += selectedOfferEl.data("count") / 2
          comboCheckoutLink += ","
          comboCheckoutLink += checkoutLinkEl.attr("href").split(":")[2].split(",")[1]
          comboCheckoutLink += ":"
          comboCheckoutLink += selectedOfferEl.data("count") / 2
          comboCheckoutLink += "?discount=" + selectedOfferEl.data("code")
          checkoutLinkEl.attr("href", comboCheckoutLink)
        } else {
          checkoutLinkEl.attr("href", checkoutLinkBase + ":" + selectedOfferEl.data("count") + "?discount=" + selectedOfferEl.data("code"))
        }
        var mobileFlavor = $(".landing-selector-wrapper .mobile .flavor-select-menu .selected").first().text()
        changeMobileFlavorImage(mobileFlavor, selectedOfferEl.data("count"), chooseMobileImageType())
      } else {
        changeMobileFlavorImage("Originals (Variety)", selectedOfferEl.data("count"), chooseMobileImageType())
      }
      
    });

    function chooseImageType() {
      var imageBatch;
      if (window.location.href.includes("super-flex")) {
        imageBatch = flexSuperImages
      } else if (window.location.href.includes("buy-three-get-two") || window.location.href.includes("pages/dozen")) {
        imageBatch = flexBogoImages
      } else {
        imageBatch = flexImages
      }
      return imageBatch
    }

    function ingredientsFlavorChange(flavor) {      
      var flavorPanelSelector = flavor.replaceAll(" ", "-")
      flavorPanelSelector = flavorPanelSelector.toLowerCase()

      $(".landing-nutrition-info .landing-supplements-ingredients .panel").removeClass("show")
      $(".landing-nutrition-info .landing-supplements-ingredients .panel").addClass("hide")
      $(".landing-nutrition-info .landing-supplements-ingredients #" + flavorPanelSelector).removeClass("hide")
      $(".landing-nutrition-info .landing-supplements-ingredients #" + flavorPanelSelector).addClass("show")

      var nutritionMatrix = {
        "ginger": "nutrition45",
        "blackberry": "nutrition45",
        "peach-mango": "nutrition45",
        "apple": "nutrition50",
        "lemon-lime": "nutrition45",
        "strawberry-kiwi": "nutrition35",
        "strawberry": "gummies-nutrition",
        "sour-lemon-lime": "gummies-nutrition"
      }

      $(".landing-nutrition-info .landing-new-supplement-img").addClass("hidden")
      $(".landing-nutrition-info .landing-new-supplement-img#" + nutritionMatrix[flavorPanelSelector]).removeClass("hidden")
    }

    // var outOfStockId = "31949827506230" // originals variety
    var outOfStockId = "placeholder-id"

    function handleOutOfStock(variantId) {
      if (variantId == outOfStockId && $(".bogo-landing-selector").length == 0) {
        $(".single-option-selector").css("text-decoration", "line-through")
        $(".add-to-cart-container .out-of-stock-button").show()
        $(".add-to-cart-container #AddToCart").hide()
      } else {
        $(".single-option-selector").css("text-decoration", "none")
        $(".add-to-cart-container .out-of-stock-button").hide()
        $(".add-to-cart-container #AddToCart").show()
      }
    }

    function outOfStockAnimation(selector) {
      $(selector).animate({'opacity': 0}, 500, function() {
        $(selector).css("text-decoration", "none")
        $(selector).html("<span class='out-of-stock-alert'>Out of Stock</span>").animate({'opacity': 1}, 1500, function() {
          $(selector).animate({'opacity': 0}, 1500, function() {
            $(selector).css("text-decoration", "line-through")
            $(selector).html("Originals (Variety)").animate({'opacity': 1}, 500)
          })
        })
      })
    }

    // Delegated so the handler survives the subscribe page's buy-box swap
    $(document).on('click', ".frequency-select-menu-option", function() {
      var selectedFrequency = $(this).text()

      $(this).closest(".frequency-wrapper").find(".single-option-selector").val($(this).text()).change()
      $(this).closest(".frequency-wrapper, #ReChargeForm_frequency").find(".frequency-select-menu-option").removeClass("selected")
      $(this).addClass("selected")
      $(".frequency-select-menu").hide()
      
      var frequencyVal = 1;
      var frequencyName = "Delivery every 1 Month"
      if (selectedFrequency == "Every 3-Months") {
        frequencyVal = 3;
        frequencyName = "Delivery every 3 Months"
      } else if (selectedFrequency == "Every 5-Months") {
        frequencyVal = 5;
        frequencyName = "Delivery every 5 Months"
      }

      var sellingPlanId = $('.rc-selling-plans__dropdown').find("option[data-plan-option='" + frequencyName + "']").val();

      $(".rc-selling-plans__dropdown").val(sellingPlanId)
      $("#ReChargeForm_frequency #product-frequency-selector").val(frequencyVal)
    })

    // Delegated so the handler survives the subscribe page's buy-box swap
    $(document).on('click', ".flavor-select-menu-option", function() {
      var isBundle;

      if ($(this).closest(".landing-nutrition-info").length > 0) {
        ingredientsFlavorChange($(this).text())
        $(this).closest(".flavor-wrapper").find(".single-option-selector").val($(this).text()).change()
        $(this).closest(flavorSelectMenuSelector).find(".flavor-select-menu-option").removeClass("selected")
      } else {
        var flavorContainer = $(this).closest(".landing-flavor-container")
        isBundle = flavorContainer.attr("data-bundle") == "true"

        if (isBundle) {
          if ($(this).data("id") == outOfStockId) {
            outOfStockAnimation(this)
          } else {
            $(this).closest(".flavor-wrapper").find(".single-option-selector").val($(this).text()).change()
            $(this).closest(flavorSelectMenuSelector).find(".flavor-select-menu-option").removeClass("selected")
          }          
        } else {
          handleOutOfStock($(this).data("id"))

          if ($(this).data("id") == outOfStockId && $(".bogo-landing-selector").length > 0) {
            outOfStockAnimation(this)
          } else {
            $(".variety-flavor-breakdown span").hide()
            if ($(this).text() == "Originals (Variety)") {
              $(".variety-flavor-breakdown span.originals-flavors").show()
            } else if ($(this).text() == "Favorites (Variety)") {
              $(".variety-flavor-breakdown span.favorites-flavors").show()
            }

            $(this).closest(".landing-selector-wrapper, .product-details-container").find(".flavor-wrapper .single-option-selector").val($(this).text()).change()
            $(this).closest(".flavor-wrapper").find(flavorSelectMenuSelector + " .flavor-select-menu-option").removeClass("selected")
            changeFlavorImages($(this).text(), chooseImageType())
            changeMobileFlavorImage($(this).text(), $(".select-this-offer.selected").data("count"), chooseMobileImageType())
          }
        }
      }
      
      if (!isBundle || $(this).data("id") != outOfStockId) {
        if (!($(".bogo-landing-selector").length > 0 && $(this).data("id") == outOfStockId)) {
          $(this).addClass("selected")
          $(".flavor-select-menu").hide()

          if (isBundle) {
            setFlavorPopupUrl($(this).closest(".landing-selector-wrapper, .offer-prices"))
          }
        }
      }
    })

    var closeFlavorMenu = function(target) {
      var container = $(flavorSelectMenuSelector);

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(target) && container.has(target).length === 0) {
        container.hide();

      }
    } 

    var closeFrequencyMenu = function(target) {
      var container = $(".frequency-select-menu");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(target) && container.has(target).length === 0) {
        container.hide();
        
      }
    }  

    $(document).mouseup(function(e) {
      closeFlavorMenu(e.target)
      closeFrequencyMenu(e.target)
    });

    $(document).on('touchend', function(e) {
      closeFlavorMenu(e.target)
      closeFrequencyMenu(e.target)
    });
  }

  waitForQtySelectorToDisplay(".product-single__qty-select-wrapper .js-qty__num", 100)

  function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
  }

  if (window.location.href.includes("newaccount=")) {
    var newEmail = decodeURIComponent(getUrlVars()["newaccount"])
    $("#create_customer input#Email").val(newEmail)
  }

  function formatReviewBadge(widget) {
    var badge = widget.querySelector(".jdgm-prev-badge");
    var text = widget.querySelector(".jdgm-prev-badge__text");
    if (!badge || !text) return;
    var count = parseInt(badge.getAttribute("data-number-of-reviews"), 10);
    if (isNaN(count)) return;
    var label = count.toLocaleString("en-US") + (count === 1 ? " review" : " reviews");
    var rating = parseFloat(badge.getAttribute("data-average-rating"));
    if ($(widget).closest(".home-testimonials-section").length && !isNaN(rating)) {
      text.innerHTML = "<b>" + rating.toFixed(1) + " stars</b> (" + label + ")";
    } else {
      text.textContent = label;
    }
  }

  window.initReviewBadges = function(root) {
    $(root || document).find(".jdgm-preview-badge").each(function(_, widget) {
      if (widget.classList.contains("jdgm--done-setup")) {
        formatReviewBadge(widget);
        return;
      }
      var observer = new MutationObserver(function() {
        if (!widget.classList.contains("jdgm--done-setup")) return;
        observer.disconnect();
        formatReviewBadge(widget);
      });
      observer.observe(widget, { attributes: true, attributeFilter: ["class"] });
    });
  };

  window.initReviewBadges();


  function tiktokLibrary(){
    if (typeof ttq !== "undefined") {
      if ($(".landing-page-new").length > 0) {
        ttq.track('ViewContent')
      }
    }
    else {
      setTimeout(tiktokLibrary, 250);
    }
  }

  setTimeout(tiktokLibrary,250);

  // Flex Landing Page Fire Add To Cart Event on Landing Page CTA Buttons
  $(".landing-page-new .checkout-link, .landing-page-new .flavor-popup-cta-link").click(function(event) {
    // event.preventDefault();
    ga("send", "event", {eventCategory: "EnhancedEcommerce", eventAction: "Added Product", eventLabel: undefined, nonInteraction: true})
    gtag("event", "add_to_cart", {
      currency: "USD",
      value: 23.99,
      items: []
    });
    fbq('track', 'AddToCart');
    ttq.track('AddToCart');
  })

  // Fire Add To Cart Event on Landing Page CTA Buttons
  $(".landing-page-trynow .cta-button, .landing-pg-science .cta-button, .landing-page-shopnow .cta-button, .landing-page-header-content .cta-button").click(function() {
    ga("send", "event", {eventCategory: "EnhancedEcommerce", eventAction: "Added Product", eventLabel: undefined, nonInteraction: true})
    gtag("event", "add_to_cart", {
      currency: "USD",
      value: 23.99,
      items: []
    });
    fbq('track', 'AddToCart');
    ttq.track('AddToCart');
  })

  // Handle Subscription Landing Page Add To Cart
  var isDynamicSubscription = getUrlVars()["subscription"] == "true"
  var isBulkDiscountSubscription = getUrlVars()["bulk"] == "true"
  var isFirstMonthOfferSubscription = getUrlVars()["firstmonth"] == "true"
  var isFirstMonthOfferSubscriptionNoCode = getUrlVars()["subscribecode"] == "false"
  var isFirstMonthOfferSixty = getUrlVars()["sixty"] == "true"
  var bulkDiscountCode = getUrlVars()["code"]

  if (isDynamicSubscription) {
    function redirectToReChargeCheckout(code) {
      function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
      do {
              token=get_cookie('cart');
      }
      while(token == undefined);

      var myshopify_domain='proper-wild-test-store.myshopify.com'
      try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
      var discount_param = 'discount=' + code
      checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+discount_param+"&"+ga_linker;

      window.location.href = checkout_url;
    }

    if (isBulkDiscountSubscription) {
      redirectToReChargeCheckout(bulkDiscountCode)
    } else if (isFirstMonthOfferSubscription) {
      $.post('/cart/clear.js').always(function(data) {
        $.post('/cart/add.js', {
          items: [
            {
              quantity: 1,
              id: getUrlVars()["variant"],
              properties: {
                shipping_interval_frequency: "30",
                shipping_interval_unit_type: "Days"
              }
            }
          ]
        }).always(function()  {
          if (isFirstMonthOfferSubscriptionNoCode) {
            redirectToReChargeCheckout("")
          } else {
            if (isFirstMonthOfferSixty) {
              redirectToReChargeCheckout("FIRSTMONTHSIXTY")
            } else {
              redirectToReChargeCheckout("FIRSTMONTHFIVE")
            }
          }
        }); 
      })
    } else {
      $.post('/cart/clear.js').always(function(data) {
        $.post('/cart/add.js', {
          items: [
            {
              quantity: 2,
              id: getUrlVars()["variant"],
              properties: {
                shipping_interval_frequency: "30",
                shipping_interval_unit_type: "Days"
              }
            }
          ]
        }).always(function()  {
            redirectToReChargeCheckout("PROPERWELCOME")
        }); 
      })
    }
  }

  // Handle Landing Flavor Selection Changes
  $(".landing-flavor-container .flavor-select-menu-option").click(function() {
    var flavorContainer = $(this).closest(".landing-flavor-container")
    var isBundle = flavorContainer.attr("data-bundle") == "true"

    if ($(this).closest(".landing-nutrition-info").length < 1 && isBundle == false) {
      var variantId = $(this).attr("data-id")
      var packCount = $(this).closest(".flavor-select-menu").attr("data-id")
      
      //if ($("#buy-three-get-two-free").length > 0) {
      //  var checkoutLink = $(".trynow-new-content .checkout-link, .shopnow-new-content .checkout-link")
      //} else {
      var checkoutLink = $(".landing-page-new .checkout-link")
      //}

      if (checkoutLink.attr("href").includes("initializing")) {
        var linkBase = checkoutLink.attr("href").split("&")[0]
        var fullLink = linkBase + "&variant=" + variantId
      } else {
        var linkQuantity;
        //if ($("#buy-three-get-two-free").length > 0) {
        //  linkQuantity = 5;
        //} else {
          linkQuantity = 1;
        //}
        
        if (variantId == "combo") {
          var originalsId = $(".flavor-select-menu-option#originals-variety-option").attr("data-id")
          var favoritesId = $(".flavor-select-menu-option#favorites-variety-option").attr("data-id")
          var fullLink = "https://properwild.com/cart/" + originalsId + ":" + linkQuantity / 2 + "," + favoritesId + ":" + linkQuantity / 2 + "?" + checkoutLink.attr("href").split("?")[1]
        } else {
          var fullLink = "https://properwild.com/cart/" + variantId + ":" + linkQuantity + "?" + checkoutLink.attr("href").split("?")[1]
        }        
      }
      
      if (packCount) {
        checkoutLink.each(function( index ) {
          if ($(this).hasClass("mobile-flex")) {
            var linkQuantity = $(this).closest(".landing-selector-wrapper").find(".select-this-offer.selected").data("count")
          } else {
            var linkQuantity = $(this).closest(".landing-qty-option").find(".flavor-select-menu").attr("data-id")
          }
          if (variantId == "combo") {
            var originalsId = $(".flavor-select-menu-option#originals-variety-option").attr("data-id")
            var favoritesId = $(".flavor-select-menu-option#favorites-variety-option").attr("data-id")
            var fullLink = "https://properwild.com/cart/" + originalsId + ":" + linkQuantity / 2 + "," + favoritesId + ":" + linkQuantity / 2 + "?" + $(this).attr("href").split("?")[1]
          } else {
            var fullLink = "https://properwild.com/cart/" + variantId + ":" + linkQuantity + "?" + $(this).attr("href").split("?")[1]   
          }
          
          $(this).attr("href", fullLink)
        })
      } else {
        checkoutLink.attr("href", fullLink)
      }
    }
  })

  function setFlavorPopupUrl(landingSelectorWrapper){
    var flavorOptions = {}
    var discountMatrix = {
      1: "WELCOME20",
      2: "WELCOME25",
      3: "PROPERWILD30",
      4: "WELCOME4",
      5: "THIRTYDAYWELCOME",
      8: "WELCOME8"
    }

    if (window.location.href.includes("super-flex")) {
      discountMatrix[2] = "WELCOME2"
    }

    if (window.location.href.includes("flex-thirty-day")) {
      discountMatrix[2] = ""
    }

    if (window.location.href.includes("adhd-flex-welcome-offer-2")) {
      discountMatrix[1] = ""
      discountMatrix[2] = "WELCOME10"
    }

    if (window.location.href.includes("adhd-flex-welcome-offer-3")) {
      discountMatrix[2] = "WELCOME20OFF"
      discountMatrix[3] = "WELCOME25OFF"
      discountMatrix[4] = "WELCOME30OFF"
    }

    if (window.location.href.includes("adhd-flex-welcome-offer-4")) {
      discountMatrix[1] = "WELCOME10OFF"
      discountMatrix[3] = "20WELCOME"
      discountMatrix[5] = "40WELCOME"
    }

    if (window.location.href.includes("shots-gummies")) {
      discountMatrix[1] = "FIRSTORDER20"
      discountMatrix[2] = "GUMMIES20,FREE6PACK"
      discountMatrix[3] = "FIRSTORDER30"
    }

    if (window.location.href.includes("pages/gummies-flex")) {
      discountMatrix[1] = "FIRSTORDER20"
      discountMatrix[2] = "FIRSTORDER25"
      discountMatrix[3] = "FIRSTORDER30"
    }

    landingSelectorWrapper.find(".subscription-tooltip .flavor-select-menu").find(".flavor-select-menu-option").each(function( index ) {
      flavorOptions[$(this).attr("data-id")] = 0
    })

    var bundleSize = 0

    landingSelectorWrapper.find(".subscription-tooltip").find(".landing-flavor-container").each(function( index ) {
      if ($(this).hasClass("available")) {
        bundleSize += 1
        var flavorId = $(this).find(".flavor-select-menu-option.selected").attr("data-id")
        flavorOptions[flavorId] += 1
      }
    })

    var baseLink = "https://properwild.com/cart/"

    $.each(flavorOptions, function(k,v) {
      if (v > 0) {
        baseLink = baseLink + k + ":" + v + ","
      }
    })

    if (window.location.href.includes("pages/gummies-flex-tote")) {
      discountMatrix[3] = "FIRSTORDER30,FREETOTE"
      if (bundleSize == 3) {
        baseLink = baseLink + "49394919964974:1"
      }
    }

    baseLink = baseLink + "?discount=" + discountMatrix[bundleSize]
    
    // landingSelectorWrapper.find(".subscription-tooltip").find(".flavor-popup-cta-link").attr("href", baseLink)
    $(".subscription-tooltip .flavor-popup-cta-link").attr("href", baseLink)
  }

  $(".flavor-bundle-tooltip .close-tooltip").click(function() {
    $(".account__loading-overlay").hide()
  })

  function resetFlavorDropdowns(tooltip) {
    tooltip.find(".flavor-select-menu").each(function( index ) {
      $(this).find(".flavor-select-menu-option").removeClass("selected")
      $(this).find(".flavor-select-menu-option").first().addClass("selected")
      var firstOptionText = $(this).closest(".flavor-wrapper").find(".single-option-selector option").first().text()
      $(this).closest(".flavor-wrapper").find(".single-option-selector").val(firstOptionText).change()

      // rotate gummies landing page default flavor
      if (window.location.href.includes("/gummies-flex")) {
        var todayDate = new Date()
        var todayNumber = todayDate.getDate()

        if (todayNumber % 2 == 0) {
          var strawberrySelector = $(".flavor-select-menu-option[data-id='47760735174958']")
          var sourSelector = $(".flavor-select-menu-option[data-id='47760735207726']")
          strawberrySelector.removeClass("selected")
          sourSelector.addClass("selected")
          $(this).closest(".flavor-wrapper").find(".single-option-selector").val(sourSelector.first().text()).change()
        }
      }
    })
  }

  function showSecondPageFlavors(tooltip, secondPageArray) {
    $.each([ 1, 2, 3, 4 ], function( index, value ) {
      tooltip.find(".landing-flavor-container[data-id='" + value + "']").fadeOut("slow", function() {
        $.each(secondPageArray, function( index, value ) {
          tooltip.find(".landing-flavor-container[data-id='" + value + "']").fadeIn("slow")
        });
      })
    });
    tooltip.find(".cta-button").text("Buy Now")
    $(".flavor-bundle-tooltip .back-tooltip").show()
  }

  var nextFourBoxesText = "Select Next 4 Boxes"

  if (window.location.href.includes("thirty-day-welcome") || window.location.href.includes("adhd-flex-welcome-offer-4")) {
    nextFourBoxesText = "Select Fifth Box"
  }

  $(".flavor-bundle-tooltip .back-tooltip").click(function() {
    var secondPageArray = [ 5, 6, 7, 8 ]
    if (window.location.href.includes("thirty-day-welcome") || window.location.href.includes("adhd-flex-welcome-offer-4")) {
      secondPageArray = [ 5 ]
    }

    var tooltip = $(this).closest(".flavor-bundle-tooltip")
    $.each(secondPageArray, function( index, value ) {
      tooltip.find(".landing-flavor-container[data-id='" + value + "']").fadeOut("slow", function() {
        $.each([ 1, 2, 3, 4 ], function( index, value ) {
          tooltip.find(".landing-flavor-container[data-id='" + value + "']").fadeIn("slow")
        });
      })
    });
    tooltip.find(".cta-button").text(nextFourBoxesText)
    $(".flavor-bundle-tooltip .back-tooltip").hide()
  })

  // Flavor Selection Popup
  $(".select-flavor-button, .gummies-bottles-offer-section .offer-details-container .select-flavors-button").click(function(e) {
    e.preventDefault()
    
    var tooltip = $(this).closest(".landing-selector-wrapper, .offer-prices").find(".flavor-bundle-tooltip")

    resetFlavorDropdowns(tooltip)
    $(".flavor-bundle-tooltip .back-tooltip").hide()

    var popupHeightMatrix = {
      "1": "360px",
      "2": "420px",
      "3": "480px",
      "4": "500px",
      "5": "500px",
      "8": "500px"
    }

    var comboPopupHeightMatrix = {
      "1": "365px",
      "2": "500px",
      "3": "520px"
    }

    var gummiesPopupHeightMatrix = {
      "1": "280px",
      "2": "345px",
      "3": "420px"
    }

    if (window.innerWidth > 768) {
      $("body").append("<div class='account__loading-overlay'></div>");
    }
    var bundleCount = $(this).attr("data-qty")
    if ($(".gummies-shots-landing-page").length > 0) {
      tooltip.css("height", comboPopupHeightMatrix[bundleCount])
    } else if ($(".gummies-landing-page").length > 0) {
      tooltip.css("height", gummiesPopupHeightMatrix[bundleCount])
    } else {
      tooltip.css("height", popupHeightMatrix[bundleCount])
    }
    
    tooltip.find(".cta-button").text("Buy Now")
    tooltip.find(".bundle-popup-label[data-id=1]").text("Select Your " + tooltip.find(".bundle-popup-label[data-id=1]").data("label"))

    if (bundleCount > 4) {
      tooltip.find(".bundle-popup-label[data-id=1]").text("Select First 4 Boxes")
    }

    tooltip.find(".landing-flavor-container").hide()
    tooltip.find(".landing-flavor-container").removeClass("available")
    tooltip.find(".landing-flavor-container[data-id='1']").show()
    tooltip.find(".landing-flavor-container[data-id='1']").addClass("available")
    tooltip.find(".free-gift-details").hide()

    $(".flavor-bundle-tooltip .single-option-selector").removeClass("mini-dropdown")
    if (bundleCount > 1) {
      tooltip.find(".landing-flavor-container[data-id='2']").show()
      tooltip.find(".landing-flavor-container[data-id='2']").addClass("available")
    }
    if (bundleCount > 2) {
      tooltip.find(".landing-flavor-container[data-id='3']").show()
      tooltip.find(".landing-flavor-container[data-id='3']").addClass("available")
      if (window.location.href.includes("pages/gummies-flex-tote")) {
        tooltip.find(".free-gift-details").show()        
      }
    }
    if (bundleCount > 3) {
      tooltip.find(".landing-flavor-container[data-id='4']").show()
      tooltip.find(".landing-flavor-container[data-id='4']").addClass("available")
      $(".flavor-bundle-tooltip .single-option-selector").addClass("mini-dropdown")
    }
    if (bundleCount > 4) {
      tooltip.find(".cta-button").text(nextFourBoxesText)
      var secondPageArray
      if (bundleCount == 5) { secondPageArray = [5] } else { secondPageArray = [5, 6, 7, 8] }
      $.each(secondPageArray, function( index, value ) {
        tooltip.find(".landing-flavor-container[data-id='" + value + "']").addClass("available")
      });

      tooltip.find(".flavor-popup-cta-link").click(function(e) {
        if (tooltip.find(".cta-button").text() == nextFourBoxesText) {
          e.preventDefault()
          showSecondPageFlavors(tooltip, secondPageArray)
        }
      })
    } 

    setFlavorPopupUrl($(this).closest(".landing-selector-wrapper, .offer-prices"))
    tooltip.toggle()
  })

  if (window.innerWidth < 769) {
    var noSmsPopupCookie = document.cookie.indexOf('properwildnosmspop=true') >= 0;

    if (!noSmsPopupCookie) {
      if (window.location.href.includes("/account") == false) {
        setTimeout(function() {
          $(".sms-popup").show().animate({bottom: "4vw"}, 1000);
        }, 3000);
      }

      $(".sms-popup .cta-button").click(function() {
        document.cookie = "properwildnosmspop=true;Max-Age=31536000;";
      })

      $(".sms-popup-close").click(function() {
        document.cookie = "properwildnosmspop=true;Max-Age=31536000;";
        $(".sms-popup").hide();
      })
    }
  }

  $("#your-shopping-cart .bulk_discount-grid__item .bulk_discount_link.show-tooltip").click(function(e) {
    e.preventDefault()
    $('.cart-bulk-discoun-tooltip').show()
    $("body").append("<div class='account__loading-overlay'></div>");
  })

  // Landing Page UGC Carousel GA Events
  $(".gummies-shots-landing-page .ugc-carousel .ugc-carousel-item").click(function(e) {
    ga('send', 'event', 'click', 'ugc_video_play');
    gtag("event", "ugc_video_play", {});
  })

  function waitForCartToLoad(selector, time) {
    if($(selector).length > 0) {
      $(".mobile-cart__table .mobile-cart__row").each(function(index) {
        $(this).find(".js-qty__adjust").attr("data-line", index + 1)
      })
      return;
    }
    else {
      setTimeout(function() {
        waitForCartToLoad(selector, time);
      }, time);
    }
  }

  if ($(".mobile-cart__table").length > 0) {
    waitForCartToLoad(".mobile-cart__table .mobile-cart__row .js-qty__adjust", 100)
  }

  // Caffeine overdose calculator
  $("#calculator-placeholder").append($("#caf-calculator"));

  // Add cta class to Reharge Quickactions buttons
  function waitForQuickActionsToLoad(selector, time) {
    if($(selector).length > 0) {
      $(selector).addClass("cta-button").css("text-transform", "capitalize");
      $("#quickactions .qa-container h2").css("text-transform", "capitalize");
      $(selector).on("click", function() {
        $(window).scrollTop(0);
      });
      setTimeout(function() {
        waitForQuickActionsToLoad(selector, time);
      }, time); 
    }
  }

  waitForQuickActionsToLoad("#quickactions .qa-button", 200);

  handleOutOfStock(getUrlVars()["variant"])

  // Add alt text to blog images
  var firstAdAltText = "Try Proper Wild for 30% Off"
  var secondAdAltText = "Energy and Focus Without the Junk. Try Proper Wild for 30% Off"

  var firstAdImage = "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blog_Ad_1.jpg?v=1742849722"
  var secondAdImage = "https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blog_Ad_2_d44b2924-3c5d-41c9-8126-9b9e80f6cf37.jpg?v=1742849766"

  var freeShotUrl = "https://try.gotoaisle.com/free-shot?utm_source=website&utm_medium=blog"

  $(".blog-article-content img[data-src='https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blog_Ad_3_2.jpg?v=1647962324'").each(function(index) {
    $(this).attr("alt", firstAdAltText)
    $(this).attr("data-src", firstAdImage)
    $(this).closest("a").attr("href", freeShotUrl)
  })

  $(".blog-article-content img[data-src='https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blog_Ad_3.jpg?v=1676997108'").each(function(index) {
    $(this).attr("alt", firstAdAltText)
    $(this).attr("data-src", firstAdImage)
    $(this).closest("a").attr("href", freeShotUrl)
  })

  $(".blog-article-content img[src='https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blog_Ad_3_2.jpg?v=1647962324'").each(function(index) {
    $(this).attr("alt", firstAdAltText)
    $(this).attr("data-src", firstAdImage)
    $(this).closest("a").attr("href", freeShotUrl)
  })

  $(".blog-article-content img[data-src='https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Proper_Wild_30-2_cd6757e9-0c01-4c8b-9a73-6f0dcfd1cc99.jpg?v=1647962325'").each(function(index) {
    $(this).attr("alt", secondAdAltText)
    $(this).attr("data-src", secondAdImage)
  })

  $(".blog-article-content img[data-src='https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Blog_Ad_2.jpg?v=1676997141'").each(function(index) {
    $(this).attr("alt", secondAdAltText)
    $(this).attr("data-src", secondAdImage)
  })

  $(".blog-article-content img[data-src='https://cdn.shopify.com/s/files/1/0019/2020/4854/files/Proper_Wild_30-2.jpg?v=1631883899'").each(function(index) {
    $(this).attr("alt", secondAdAltText)
    $(this).attr("data-src", secondAdImage)
  })

  // Accordian Aria Label Updates For Accessibility
  $(".accordion").click(function(e) {
    var control = $(this)

    if (control.attr("aria-expanded") == "false") {
      control.attr("aria-expanded", "true")    
    } else {
      control.attr("aria-expanded", "false")
    }
  })

  // Free Shot Form
  var freeShotFormSelector = "#free-shot-form"
  $(freeShotFormSelector).submit(function(e){
    e.preventDefault();
    $("body").append("<div class='rewards__loading-overlay'><div class='rewards__loading-spinner'></div></div>");


    var referralUrl = "properwild.com"
    if ($("#free-shot").length > 0) {
      referralUrl = "properwild.com/pages/free-shot"
    }

    var utmCampaign = ""
    var utmSource = ""
    var utmMedium = ""

    var urlParams = getUrlVars()

    if (urlParams["utm_campaign"]) { utmCampaign = urlParams["utm_campaign"] }
    if (urlParams["utm_source"]) { utmSource = urlParams["utm_source"] }
    if (urlParams["utm_medium"]) { utmMedium = urlParams["utm_medium"] }

    var dataVars = {
      customerPhoneNumber: $(freeShotFormSelector + " input[name='telephone']").val(),
      campaignPhoneNumber: "816-844-3654",
      email: $(freeShotFormSelector + " input[name='email']").val(),
      utmCampaign: utmCampaign,
      utmSource: utmSource,
      utmMedium: utmMedium,
      referrerUrl: referralUrl
    }

    $.ajax({
      headers: {
        "X-Api-Key": "U2FsdGVkX1/TOmHSnrKjLmDLsvFHhlrA3JYgTdbg+rqQ4pEiRsD6RL49nkhh3R+M"
      },
      type: "POST",
      url: "https://console.gotoaisle.com/api/webhooks/manual-input",
      data: dataVars,
      error: function(data) {
        console.log("error")
        $(".rewards__loading-overlay, .rewards__loading-spinner").hide();
        $(".free-shot-error-message").show()
      },
      success: function(data) {
        console.log("finished")
        $(".rewards__loading-overlay, .rewards__loading-spinner").hide();
        if (data.code == "ConvoReengaged" || data.code == "NewConvoCreated") {
          fbq('track', 'Lead');
          $(freeShotFormSelector).css("opacity", 0)
          $(".free-shot-success-message").show()
        } else {
          console.log("error")
          $(".rewards__loading-overlay, .rewards__loading-spinner").hide();
          $(".free-shot-error-message").show()
        }
      }
    })
  });

  // Desktop nav panel slidedown
  $(".site-header__shop-now-btn").click(function(e){
    e.preventDefault();

    var sliderSelector = ".desktop-nav-slider"
    var fixedNavSelector = ".fixed-nav"
    var sliderSpeed = "slow"

    if ($(sliderSelector).is(":visible")) {
      $(sliderSelector).slideUp(sliderSpeed);
      if ($(window).scrollTop() > 0) {
        $(fixedNavSelector).animate({
          "opacity": 0.95
        }, 1000, function() {})
      }
    } else {
      $(sliderSelector).slideDown(sliderSpeed);
      $("header.site-header").addClass("fixed-nav");
      $(fixedNavSelector).css("opacity", 1)
    }
  });
  
  if ($("#quickactions").length > 0) {
    $("body").addClass("recharge-skip-page")
  }

  // Homepage scrolling banner (people-usage bar)
  $(document).ready(function () {
      var $tickerWrapper = $(".people-usage");
      var $scrollingList = $tickerWrapper.find(".scrolling-container");
      if ($tickerWrapper.length === 0 || $scrollingList.length === 0) {
          return;
      }
      if (typeof TimelineMax === "undefined") {
          return;
      }
      $scrollingList.css("animation", "none");
      var $clonedList = $scrollingList.clone().addClass("cloned").appendTo($tickerWrapper);
      var infiniteScrollTimeline;
  
      setupTicker();
  
      // Recalculate on window resize
      //$(window).resize(function () {
      //    setupTicker();
      //}); 
  
      /**
       * Initializes or updates the ticker animation.
       */
      function setupTicker() {
          // Calculate the new list width
          var listWidth = calculateListWidth($scrollingList);
  
          // Update the width of both lists
          $scrollingList.add($clonedList).css({ "width": listWidth + "px" });
  
          // Determine animation duration based on screen size and list width
          const isDesktop = $(window).width() > 768;
          const baseDuration = 10; // Base duration in seconds
          const speedFactor = listWidth / 500; // Adjust this factor as needed
          var animationDuration = isDesktop ? baseDuration * speedFactor : baseDuration * speedFactor / 2;
  
          // Destroy the previous timeline if it exists
          if (infiniteScrollTimeline) {
              infiniteScrollTimeline.kill();
          }
  
          // Create a new infinite scrolling animation
          infiniteScrollTimeline = createInfiniteScroll($scrollingList, $clonedList, listWidth, animationDuration);
      }
  
      /**
       * Calculates the total width of the list including all its items.
       */
      function calculateListWidth($list) {
          var width = 10; // Start with some padding
          $list.find(".each-container").each(function () {
              width += $(this).outerWidth(true) + 30; // Add the width of each item
          });
          return width;
      }
  
      /**
       * Creates an infinite scrolling animation for the lists.
       */
      function createInfiniteScroll($list, $clonedList, listWidth, duration) {
          var timeline = new TimelineMax({ repeat: -1, paused: true });
  
          timeline
              .fromTo(
                  $list,
                  duration,
                  { rotation: 0.01, x: 0 },
                  { force3D: true, x: -listWidth, ease: Linear.easeNone },
                  0
              )
              .fromTo(
                  $clonedList,
                  duration,
                  { rotation: 0.01, x: listWidth },
                  { force3D: true, x: 0, ease: Linear.easeNone },
                  0
              )
              .set($list, { force3D: true, rotation: 0.01, x: listWidth })
              .to(
                  $clonedList,
                  duration,
                  { force3D: true, rotation: 0.01, x: -listWidth, ease: Linear.easeNone },
                  duration
              )
              .to(
                  $list,
                  duration,
                  { force3D: true, rotation: 0.01, x: 0, ease: Linear.easeNone },
                  duration
              )
              .progress(1)
              .progress(0)
              .play();
  
          return timeline;
      }
  });

});

$(document).ready(function () {
  var $lists = $(".people-usage .scrolling-container");
  if ($lists.length === 0 || typeof TimelineMax !== "undefined") {
    return;
  }
  function setCssTickerDuration() {
    var pixelsPerSecond = $(window).width() > 768 ? 50 : 100;
    $lists.each(function () {
      var width = this.scrollWidth;
      if (width > 0) {
        this.style.animationDuration = (width / 2) / pixelsPerSecond + "s";
      }
    });
  }
  setCssTickerDuration();
  $(window).on("load", setCssTickerDuration);
});

// Subscribe page product selector is handled by assets/subscribe-product-toggle.js

function startVideo () {
  let testimonialVideoSection = $(event.srcElement).parents('.testimonial-video');
  testimonialVideoSection.addClass('played');
  let testimonialVideoElement = testimonialVideoSection.find('video')[0];
  testimonialVideoElement.play()
}

$(document).on("click", function (event) {
  var sliderSelector = ".desktop-nav-slider"
  if ($(sliderSelector).is(":visible")) {
    if ($(event.target).closest("header.site-header").length === 0) {
      $(sliderSelector).slideUp("slow");
    }
  }
});